import React, {useState} from 'react';

import {Button, Input, Modal} from '@mantine/core';

import {useInitalFocus} from '@/hooks/useInitalFocus';

type Props = {
    data?: {
        title: string;
        inputName: string;
        initialValue?: string;
        onSubmit: (text: string) => void;
        suffix?: string;
    };
    close: () => void;
};

export const TextInputModal = (props: Props) => {
    return (
        <Modal
            title={props.data?.title}
            opened={Boolean(props.data)}
            onClose={props.close}
            closeOnClickOutside={false}
            withCloseButton={true}
        >
            {props.data && (
                <TextInputModalForm
                    data={props.data}
                    close={props.close}
                />
            )}
        </Modal>
    );
}

type TextInputModalFormProps = {
    data: {
        title: string;
        inputName: string;
        onSubmit: (text: string) => void;
        initialValue?: string;
        suffix?: string;
    };
    close: () => void;
}

const TextInputModalForm = (props: TextInputModalFormProps) => {
    const [text, setText] = useState(props.data.initialValue || '');
    const inputRef = useInitalFocus();

    const handleSubmit = () => {
        props.data.onSubmit(text);
        props.close();
    };

    return (
        <div>
            <div style={{margin: '10px'}}>
                <p>
                    {props.data.inputName}
                </p>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Input
                        id='text-input-modal-input'
                        autoComplete='off'
                        autoCorrect='off'
                        spellCheck={false}
                        ref={inputRef}
                        onChange={e => setText(e.target.value)}
                        value={text}
                        type='text'
                        style={{width: '80%'}}
                    />
                    {props.data.suffix && (
                        <span style={{marginLeft: '8px'}}>
                            {props.data.suffix}
                        </span>
                    )}
                </div>
            </div>

            <div
                style={{marginTop: '20px'}}
            >
                <Button
                    id='text-input-modal-submit-button'
                    size='xs'
                    disabled={!text}
                    onClick={handleSubmit}
                >
                    Submit
                </Button>

                <Button
                    size='xs'
                    ml={10}
                    variant='outline'
                    onClick={props.close}
                >
                    Cancel
                </Button>
            </div>
        </div>
    );
};
